import type { NonNullableFormBuilder } from '@angular/forms';
import { BusinessHoursFormComponent } from '../../../../../common/components/forms/business-hours-form/business-hours-form.component';
import { InformationFormComponent } from '../../../../../common/components/forms/information-form/information-form.component';
import { PhoneFormComponent } from '../../../../../common/components/forms/phone-form/phone-form.component';
import { BaseAssignedDriversFormComponent } from '../../base-form/base-assigned-drivers-form/base-assigned-drivers-form.component';
import { BaseAssignedVehiclesFormComponent } from '../../base-form/base-assigned-vehicles-form/base-assigned-vehicles-form.component';
import type { Base } from '../interfaces/base';

type BaseFormGroup = ReturnType<typeof BaseFormHelper.buildForm>;
export type BaseForm = ReturnType<BaseFormGroup['getRawValue']>;

export interface BaseFormDto {
  name: BaseForm['baseInformation']['name'];
  address: BaseForm['baseInformation']['address'];
  phone: BaseForm['contact']['phone'];
  businessHours: BaseForm['businessHours'];
  assignedVehicles: string[];
  assignedDrivers: string[];
}

export class BaseFormHelper {
  public static fromDto(dto: Base): BaseForm {
    return {
      ...dto,
      assignedDrivers: {
        selectedDrivers: dto.assignedDrivers.map((driver) => driver.uuid),
        drivers: dto.assignedDrivers.map((driver) => ({
          uuid: driver.uuid,
          driver: driver,
        })),
      },
      assignedVehicles: {
        selectedVehicles: dto.assignedVehicles.map((vehicle) => vehicle.uuid),
        vehicles: dto.assignedVehicles.map((vehicle) => ({
          uuid: vehicle.uuid,
          vehicle: vehicle,
        })),
      },
      baseInformation: {
        address: dto.address,
        name: dto.name,
      },
      contact: {
        phone: dto.phone,
      },
    };
  }

  public static buildForm(fb: NonNullableFormBuilder) {
    return fb.group({
      baseInformation: InformationFormComponent.buildForm(fb),
      businessHours: BusinessHoursFormComponent.buildForm(fb),
      contact: PhoneFormComponent.buildForm(fb, true),
      assignedVehicles: BaseAssignedVehiclesFormComponent.buildForm(fb),
      assignedDrivers: BaseAssignedDriversFormComponent.buildForm(fb),
    });
  }
}
